import React from 'react';
import { useTranslation } from 'react-i18next';
import './ErrorMessage.scss';

interface ErrorMessageProps {
  message: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  const { t } = useTranslation('common');
  return (
    <div className="error-message alert alert-danger" role="alert">
      <strong>{t('error')}:</strong> {message}
    </div>
  );
};

export default ErrorMessage;
